import React from 'react';
import { Colors, FontWeights } from 'core/CssVariables';
import { Text } from '../../../Typography';
import { Icon } from '../../../Icon';
import { TIconNames } from '../../../Icon/Icon.type';
import { TTextDatePickerProps } from '../../EditableFields.type';

const TextDatePicker: React.FC<TTextDatePickerProps> = ({
  setIsEditable,
  fontWeight,
  fontLevel,
  value,
}) => {
  const onHandleClick = () => {
    setIsEditable(true);
  };
  return (
    <Text
      className="pt-1 pb-1 pl-2"
      fontLevel={fontLevel || 5}
      fontWeight={fontWeight || FontWeights.Medium}
      onClick={onHandleClick}
      editable={{
        icon: (
          <Icon
            icon={TIconNames.EDIT}
            color={Colors.Blue}
            size={16}
            className="edit-icon ml-2"
          />
        ),
      }}
    >
      {value}
    </Text>
  );
};
export default TextDatePicker;
